import { Component, OnInit } from '@angular/core';
import { CfetPageNamesConstant, CfetBaseComponent } from '../../cfet-core';
import { environment } from '../../../environments/environment';
import { Router, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'app-utf-auth-page',
    templateUrl: './utf-auth-page.component.html',
    styleUrls: ['./utf-auth-page.component.scss'],
    standalone: false
})
export class UtfAuthPageComponent extends CfetBaseComponent implements OnInit {

  showauth: boolean = true;
  returnUrl = '';

  constructor(private router: Router, private activatedRoute: ActivatedRoute, private title: Title) {
    super();
  }

  ngOnInit () {
    this.title.setTitle(this.cfetTitles.eligibility.utfHtmlTitle);
    const domainUrl = window.location.origin;
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params && params['returnURL']) {
        this.returnUrl = params['returnURL'];
      }
    });
    if (domainUrl === environment.pilot_domain) {
      if(this.returnUrl === '') {
        window.location.href = environment.fn_logout + environment.signup_domain + CfetPageNamesConstant.UTF_SYNCING_INFO;
      } else {
        window.location.href = environment.fn_logout + environment.signup_domain + CfetPageNamesConstant.UTF_SYNCING_INFO + encodeURIComponent('?returnURL=') + encodeURIComponent(encodeURIComponent(this.returnUrl));
      }
    } else if(domainUrl === environment.utf_domain) {
      if (this.returnUrl.length !== 0) {
        sessionStorage.setItem('returnUrl', JSON.stringify(this.returnUrl));
      }
    } else if (sessionStorage.getItem('ngStorage-pilotToken') === null) {
      this.showauth = false;
      this.router.navigate([CfetPageNamesConstant.ERROR_PAGE_UTF]);
    } else {
      this.showauth = true;
      sessionStorage.removeItem('ngStorage-pilotToken');
    }
  }

}
